import { render, staticRenderFns } from "./VStudentSemiProfile.vue?vue&type=template&id=d85ab76a&"
import script from "./VStudentSemiProfile.vue?vue&type=script&lang=js&"
export * from "./VStudentSemiProfile.vue?vue&type=script&lang=js&"
import style0 from "./VStudentSemiProfile.vue?vue&type=style&index=0&id=d85ab76a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports